import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RecoveryComponent} from './recovery.component';
import {FormsModule} from '@angular/forms';
import {DefaultApi} from '../service/default.api';
import { Routes } from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBarModule} from '@angular/material/snack-bar';

export const routes: Routes = [
  {
    path: '',
    component: RecoveryComponent,
    pathMatch: 'full'

  }
];

@NgModule({
  declarations: [
    RecoveryComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatSnackBarModule
  ],
  providers: [
    DefaultApi
  ],
  exports: [
    RecoveryComponent
  ]
})
export class RecoveryModule {
  static routes = routes;
}
